export default "__VITE_ASSET__DNBCo$4j__"